import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'date-select-field',
  templateUrl: './date-select-field.component.html',
  styleUrls: ['./date-select-field.component.scss'],
  providers: [{
    useExisting: forwardRef(() => DateSelectFieldComponent),
    provide: NG_VALUE_ACCESSOR, multi: true
  }]
})
export class DateSelectFieldComponent implements ControlValueAccessor {

  @Input() minDate: Date | string;
  @Input() maxDate: Date | string;

  private selectedDate: Date | string;

  disabled: boolean;

  today: Date = new Date();

  constructor() { }

  get value(): any {
    return this.selectedDate;
  }

  set value(value: any) {
    if (value !== this.selectedDate) {
      this.selectedDate = value;
      this.onChangeCallback(value);
    }
  }

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};
  registerOnChange(fn: any) { this.onChangeCallback = fn; }
  registerOnTouched(fn: any) { this.onTouchedCallback = fn; }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    if (value !== this.selectedDate) {
      this.selectedDate = value;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/fields/date-select-field/date-select-field.component.ts